import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {ProjectList} from 'imports/ComponentsImports';

import {CircularProgress} from 'material-ui';

const styles = {
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  subHeader: {
    marginTop: '0px',
    paddingLeft: '20px'
  }
}

class ProjectsView extends Component {
  constructor(props){
    super(props);
    this.state = {
      error: false,
      loading: false,
      projects: []
    }
  }

  componentDidMount() {
    //this.getProjects();
  }

  getProjects = () => {
    let token = this.props.cookies.get('token');
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ token}
    });
    connection.get(routes.projectFullInformation)
      .then((response) => {
        console.log(response);
        var projects = []
        response.data.forEach((project) => {
          if(project.state.length > 0 && project.state[0].state === "Por firmar")
            projects.push(project)
        });
        this.setState({
          projects: projects,
          loading: false,
          error: false
        });
      })
      .catch((error) => {
        this.setState({ error: true, loading: false })
      });
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los proyectos. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    return (
      <div style={styles.pageContainer}>
        <h1>Proyectos a validar</h1>
        <h3 style={styles.subHeader}>Te recomendamos revisar en detalle la ficha de proyecto i3, ya que luego de que todos los actores firmen, el proyecto quedará oficialmente dentro del portafolio i3.</h3>
        <ProjectList
          history={this.props.history}
          projects={this.state.projects}
        />
      </div>
    );
  }
}

export default withCookies(withRouter(ProjectsView));



// WEBPACK FOOTER //
// ./src/views/files/SignatureView.js